<app-navbar></app-navbar>
<div class="register-friend">
  <div class="content-wrapper">
    <div class="content">
      <h1 class="ui-headline">{{ 'no_survey.referral.title' | translate: { firstName: rewards?.referrer_name } }}</h1>
      <p class="join">
        {{ 'no_survey.referral.subheading' | translate }}
      </p>
      <p class="bold">
        <span class="icon-i-gift"></span>
        <span>{{ 'no_survey.referral.incentive.' + (moneyRewards() ? 'money' : 'months') | translate: { amount: getRewardsAmount() } }}</span>
      </p>
      <div class="why">
        <h2>{{ 'no_survey.referral.contentBox.title' | translate }}</h2>
        <ul>
          <li *ngFor="let number of [1, 2, 3, 4]">
            <img src="/assets/images/icons/checkmark-filled.svg" />
            <span>{{ 'no_survey.referral.contentBox.p' + number | translate }}</span>
          </li>
        </ul>
      </div>
      <p [innerHTML]="'no_survey.referral.termsConditions' | translate"></p>
    </div>
  </div>
  <div>
    <div class="register-form">
      <app-register-form>
        <h1 class="ds-title-1 header">{{ 'no_survey.referral.signupTitle' | translate: { firstName: rewards?.referrer_name } }}</h1>
      </app-register-form>
      <app-swiss-made-footer></app-swiss-made-footer>
    </div>
  </div>
</div>
